// De kolommen van het bord: welke waarden zijn er, en wat hoort waarbij.
//
// Apart van het scherm omdat dit de enige regel is die er echt een is — en het enige stuk van
// de bordweergave dat je zonder browser kunt beproeven.

import type { Rij } from "../api.ts";

/** Notities zonder die eigenschap horen ook ergens; dit is hun kolom. */
export const ZONDER = "— zonder";

export type Kolom = { waarde: string; rijen: Rij[] };

/**
 * Groepeer op de waarde van één eigenschap.
 *
 * Op alfabet, met "zonder" altijd achteraan: dat is de bak met wat je nog moet indelen, en die
 * hoort niet vóór je eerste echte kolom te staan. Lege waarden tellen als "zonder" — een veld
 * dat er wel is maar niets zegt, is hetzelfde als geen veld.
 */
export function groepeerOpEigenschap(rijen: Rij[], sleutel: string): Kolom[] {
  const kaart = new Map<string, Rij[]>();
  for (const rij of rijen) {
    const waarde = (rij.eigenschappen ?? {})[sleutel]?.trim() || ZONDER;
    if (!kaart.has(waarde)) kaart.set(waarde, []);
    kaart.get(waarde)!.push(rij);
  }
  return [...kaart.entries()]
    .map(([waarde, rijen]) => ({ waarde, rijen }))
    .sort((a, b) =>
      a.waarde === ZONDER ? 1 : b.waarde === ZONDER ? -1 : a.waarde.localeCompare(b.waarde, "nl")
    );
}
